import expertLogin from '@/views/bidEvaluationSystem/expertLogin/index.vue'
import expertEvaluation from '@/views/bidEvaluationSystem/expertEvaluation/index.vue'
import evaluationPage from '@/views/bidEvaluationSystem/bidEvaluationSystemChild/evaluationPage.vue'
import bidListMgmt from '@/views/bidEvaluationSystem/bidEvaluationSystemChild/bidListMgmt.vue'
import qualificateStep from '@/views/bidEvaluationSystem/qualificateStep/index.vue'
import todayEvaluation from '@/views/bidEvaluationSystem/bidEvaluationSystemChild/todayEvaluation.vue'
import bidEvaluationMethod from '@/views/agent/bidEvaluation/bidEvaluationMethod.vue'
import openHall from '@/views/agent/agentChild/openHall.vue'

export default [
  {
    path: '/expertLogin',
    component: expertLogin,
    name: 'expertLogin',
  },
  {
    path: '/todayEvaluation',
    component: todayEvaluation,
    name: 'todayEvaluation',
  },
  {
    path: '/qualificateStep',
    component: qualificateStep,
    name: 'qualificateStep',
  },
  {
    path: '/expertEvaluation',
    component: expertEvaluation,
    redirect: '/expertEvaluation/bidListMgmt',
    children: [
      { path: 'bidListMgmt', name: 'bidListMgmt', component: bidListMgmt },
      { path: 'evaluationPage', name: 'evaluationPage', component: evaluationPage },
    ]
  },
  {
    path: '/openHall',
    component: openHall,
    name: 'openHall',
  },
  {
    path: '/bidEvaluationMethod',
    component: bidEvaluationMethod,
    name: 'bidEvaluationMethod',
  },
]
